import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  headerBox: {
    position: 'relative',
    width: '100%',
    background: theme.palette.custom.background.dark,
    zIndex: 2,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      padding: '16px',
    },
  },
  header: {
    background: theme.palette.custom.background.dark,
    padding: '20px 0',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      padding: 0,
    },
  },
  inner: {
    gap: 32,
    ...dFlex('initial', 'center'),

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: '100%',
    },
  },
  nav: {
    ...dFlex('initial', 'initial'),
    gap: 24,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      gap: 16,
    },
  },
  logo: {
    position: 'absolute',
    top: '36px',
    left: '50%',
    width: '100px',
    transform: 'translate(-50%, 0)',
  },
  mobileLogo: {
    height: '60px',
    width: '60px',
  },
  row: {
    ...dFlex('space-between', 'center'),

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      display: 'none',
    },
  },
  buttonWrap: {
    ...dFlex('initial', 'center'),
    gap: 16,
  },
  headerMob: {
    ...dFlex('space-between', 'center'),
  },
  wrapSideBar: {
    '& .MuiDrawer-paper': {
      background: theme.palette.custom.background.accent,
      overflow: 'scroll',

      [theme.breakpoints.down(Breakpoint.Lg)]: {
        boxSizing: 'border-box',
        width: '100%',
      },
    },
  },
}));

export default useStyles;
